import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { UsersDashboardInfoResponse } from '../models/dashboard/users-card-data';
import { StudentDashboardResponse } from '../../core/models/interfaces/student-dashboard/student-dashboard';
import { StudentNavCoursesResponse } from '../models/nav-courses-and-quizzes/get-all-courses';
import { StudentNavQuizzesResponse } from '../models/nav-courses-and-quizzes/get-all-quizzes';
import { CommonQueryParams } from '../models/query-params-common-interface.ts/query-parms-interface';
import { StudentLimitResponse } from '../models/student-courses-v2/student-limit-stats';
@Injectable({
	providedIn: 'root'
})
export class TeacherServicesService {
	apiUrl = environment.dashboardUrl;

	constructor(private http: HttpClient) { }

	getDashboardInfo(): Observable<UsersDashboardInfoResponse> {
		return this.http.get<UsersDashboardInfoResponse>(`${this.apiUrl}${environment.teacherDashboardEndpoints.teacherDashboard}`);
	}

	getStudentDashboard(): Observable<StudentDashboardResponse> {
		return this.http.get<StudentDashboardResponse>(`${this.apiUrl}${environment.teacherDashboardEndpoints.studentDashboard}`);
	}

	getAllStudentCourses(params: CommonQueryParams): Observable<StudentNavCoursesResponse> {
		const httpParams = new HttpParams({
			fromObject: {
				page: params.page ?? 1,
				page_size: params.page_size ?? 10,
				search: params.search ?? '',
				classroom_filter: params.classroom_filter ?? 1,
				teacher_filter: params.teacher_filter ?? ''
			}
		});
		return this.http.get<StudentNavCoursesResponse>(`${this.apiUrl}/student/courses`, { params: httpParams })
	}

	getAllStudentQuizzes(params: CommonQueryParams): Observable<StudentNavQuizzesResponse> {
		const httpParams = new HttpParams({
			fromObject: {
				page: params.page ?? 1,
				page_size: params.page_size ?? 10,
				search: params.search ?? '',
				classroom_filter: params.classroom_filter ?? 1,
				status_filter: params.status_filter ?? ''
			}
		});
		return this.http.get<StudentNavQuizzesResponse>(`${this.apiUrl}/student/quizzes`, { params: httpParams })
	}

	getStudentDashboardLimit(): Observable<StudentLimitResponse> {
		return this.http.get<StudentLimitResponse>(`${this.apiUrl}/limit`);
	}

}